import { Banner, BannerItem, Logo, EuItem } from "./styled";
import PlanLogo from "./images/plan.png";
import GorcePieninyLogo from "./images/gorce-pieniny.jpg";
import CzorsztyniankaLogo from "./images/logo_CMYK_kolor.png";
import EuLogo from "./images/eu.png";

const FundingBanner = () => {
    return (
        <Banner>
            <BannerItem>
                <Logo
                    src={PlanLogo}
                    alt="Plan Strategiczny dla Wspólnej Polityki Rolnej"
                />
            </BannerItem>

            <BannerItem>
                <Logo
                    src={GorcePieninyLogo}
                    alt="Stowarzyszenie Lokalna Grupa Działania Gorce-Pieniny"
                />
            </BannerItem>

            <BannerItem>
                <Logo
                    src={CzorsztyniankaLogo}
                    alt="Czorsztynianka"
                />
            </BannerItem>

            <EuItem>
                <Logo
                    src={EuLogo}
                    alt="Unia Europejska"
                />
            </EuItem>
        </Banner>
    );
};

export default FundingBanner;